<template>
  <div v-loading.absolute="isLoading" class="side-stock-view">
    <AccountProcess
      v-if="openAccountStatus"
      :context="'external'"
      @closeAccountStatus="hideAccountStatusPanel"
    />
    <div v-else class="external-view">
      <SideStockHead :stock="stockDetail" />
      <StockView
        :stock="stockDetail"
        :detail="stockDetail"
        :context="'external'"
        @showAccountStatus="showAccountStatusPanel"
      />
    </div>
  </div>
</template>
<script>
import AccountProcess from 'mod/AccountInfo/AccountProcess'
import StockView from 'mod/StockView'
import SideStockHead from './SideStockHead'
import { mapGetters } from 'vuex'
import { TIMER_EXPRESSION } from 'const/common'
import { SEC_TYPE } from 'const/stock'
import bus from 'src/eventbus'
import { getQuoteDetail } from 'apis/quote'
import isNeedRefresh from 'utils/isNeedRefresh'

const REFRESH_MINUTES_TIMER_NAME = 'refresh minutes'

export default {
  name: 'SideStockInfo',
  components: {
    AccountProcess,
    StockView,
    SideStockHead
  },
  data() {
    return {
      isLoading: false,
      openAccountStatus: false,
      detail: null
    }
  },
  computed: {
    ...mapGetters(['isDeposited', 'curAccountId', 'activeStockMark']),
    ...mapGetters({
      stock: 'activeSideStock'
    }),
    localSymbol() {
      return this.stock.webLocal
        ? this.stock.webLocal.symbol
        : this.stock.symbol
    },
    stockDetail() {
      return Object.assign({}, this.stock, this.detail)
    },
    isNeedRefresh() {
      return isNeedRefresh(this.stockDetail, this.$store.getters)
    }
  },
  mounted() {
    this.getDetail()
    this.resumeOrCreate()
    this.$store.dispatch('removeTradeRequest')
    bus.on(bus.$events.DOCUMENT_VISIBLE_CHANGE, this.refresh)
  },
  beforeDestroy() {
    bus.off(bus.$events.DOCUMENT_VISIBLE_CHANGE, this.refresh)
    if (this.timer) {
      this.timer.clear()
    }
  },
  methods: {
    resumeOrCreate() {
      if (!this.timer) {
        this.createTimer()
      } else {
        this.timer.resume()
      }
    },
    createTimer() {
      this.timer = this.$cron(TIMER_EXPRESSION.MINUTES_TIMER).interval(
        REFRESH_MINUTES_TIMER_NAME,
        this.refresh
      )
      if (!this.isNeedRefresh) {
        this.timer.pause()
      }
    },
    refresh() {
      if (this.isLoading) return
      this.getDetail()
    },
    getDetail(isLoading = false) {
      this.isLoading = isLoading
      return getQuoteDetail(this.stock)
        .then(detail => {
          this.detail = detail

          if (
            this.$route.name === 'option-chain' &&
            detail.secType === SEC_TYPE.OPT
          ) {
            this.$store.dispatch('whenStockUpdate', detail)
          }
          return detail
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    hideAccountStatusPanel() {
      this.openAccountStatus = false
    },
    showAccountStatusPanel() {
      this.openAccountStatus = true
    }
  },
  watch: {
    isNeedRefresh(yes) {
      if (!this.timer) return
      yes ? this.resumeOrCreate() : this.timer.pause()
    },
    localSymbol(newValue) {
      if (newValue) {
        this.getDetail()
        this.$store.dispatch('removeTradeRequest')
      }
    },
    activeStockMark() {
      this.$store.dispatch('closeSideStockView')
      this.$store.dispatch('removeTradeRequest')
    },
    isDeposited() {
      if (this.isDeposited) return
      this.$store.dispatch('closeSideStockView')
      this.$store.dispatch('removeTradeRequest')
    },
    curAccountId() {
      this.$store.dispatch('closeSideStockView')
      this.$store.dispatch('removeTradeRequest')
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.side-stock-view {
  position: fixed;
  top: 3px;
  bottom: 43px;
  right: 0;
  width: 320px;
  z-index: 999;
  background-color: var(--bg-block);
  display: flex;
  .external-view {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>
